import { render, staticRenderFns } from "./ClientPanel.vue?vue&type=template&id=c5f8a5cc&scoped=true"
import script from "./ClientPanel.vue?vue&type=script&lang=js"
export * from "./ClientPanel.vue?vue&type=script&lang=js"
import style0 from "./ClientPanel.vue?vue&type=style&index=0&id=c5f8a5cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5f8a5cc",
  null
  
)

export default component.exports